
import {Component, Prop, Watch} from 'nuxt-property-decorator';
import BaseInputComponent from '~/components/Form/BaseInputComponent';


@Component
export default class FormInputText extends BaseInputComponent {
  @Prop({
    type: String,
    default: 'text',
  })
  type!: string

  @Prop({
    type: Boolean,
    default: false,
  })
  disabled!: boolean

  @Prop({
    type: String,
    default: null,
  })
  value!: string

  @Prop({
    type: String,
    default: null,
  })
  autocomplete!: string

  @Prop({
    type: String,
    default: null,
  })
  pattern!: string

  @Prop({
    type: String,
    default: null,
  })
  title!: string

  @Prop({
    type: String,
    default: null,
  })
  innerClass!: string

  @Prop({
    type: [String, Object],
    default: null,
  })
  vMaska!: string | object

  innerValue: string = this.value

  @Watch('value')
  watchValue(v: string): void {
    this.innerValue = v;
  }

  @Watch('innerValue')
  watchInnerValue(v: string): void {
    // clear validation errors on input update
    this.onClearValidationErrors();

    this.$emit('input', v);
  }
}
